import React, { useMemo, useState } from 'react';
import { FormDialog, InputField, MuiBox } from '@kis-technologies/kis-ui';
import { doesFormHaveError, onInputBlur, onValueChange } from 'utils/forms';
import { configValidationSchema } from 'views/ConfigurationView/utils';
import { CreateConfigurationForm, CreateConfigurationOverlayProps } from '../types';
import { getCreateConfigurationForm } from '../utils';

const CreateConfigurationOverlay = ({ onClose, onSubmit }: CreateConfigurationOverlayProps) => {
  const initialForm = useMemo(() => getCreateConfigurationForm(), []);
  const [form, setForm] = useState<CreateConfigurationForm>(initialForm);

  const isSaveDisabled = useMemo(() => !form.name.value.trim() || doesFormHaveError(form), [form]);

  return (
    <FormDialog
      open
      title="Create Configuration"
      confirmButtonText="Save"
      confirmButtonAction={() => onSubmit(form.name.value.trim())}
      confirmButtonDisabled={isSaveDisabled}
      cancelButtonText="Cancel"
      cancelButtonAction={onClose}
    >
      <MuiBox py="16px" width="524px">
        <InputField
          autoFocus
          data-testid="configuration-name-input"
          error={form.name.error !== null}
          fullWidth
          helperText={form.name.error}
          inputProps={{ maxLength: 255 }}
          label="Name"
          onBlur={(e) => onInputBlur(e, 'name', configValidationSchema, setForm)}
          onChange={(e) => onValueChange(e.target.value, 'name', setForm)}
          size="small"
          value={form.name.value}
        />
      </MuiBox>
    </FormDialog>
  );
};

export default CreateConfigurationOverlay;
